import { LoadingSpinnerSmall } from "@dm-4dev/ui";
import { cn } from "@mod/shared/ui/cn";

type LoadingSpinnerProps = {
  className?: string;
};

export const LoadingSpinner = ({ className }: LoadingSpinnerProps) => {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn("flex flex-col items-center justify-center gap-3", className)}
    >
      <img src="/comu-app-logo.png" alt="Loading..." className="h-16 w-16 object-contain animate-heartbeat" />
      <LoadingSpinnerSmall size="sm" className="border-primary !mr-0 h-4 w-4" />
    </div>
  );
};
